<div class="bottom-directions" i18n>Snow trails</div>

<ul class="list-unstyled">
  <li class="trail-type-layer">
    @if (!isShowingSatellite) {
      <img alt="Trunk Trails" ngSrc="/assets/icons/map-legend-icons/sno/icon-snowtrails-trunk.svg" i18n-alt />
    } @else {
      <img alt="Trunk Trails" ngSrc="/assets/icons/map-legend-icons/sno/icon-snowtrails-trunk-sat.svg" i18n-alt />
    }
    <div>
      <strong i18n>Trunk: </strong>
      <span i18n>Corridor connecting trails</span>
    </div>
  </li>
  <li class="trail-type-layer">
    @if (!isShowingSatellite) {
      <img alt="Trail" ngSrc="/assets/icons/map-legend-icons/sno/icon-snowtrails-trail.svg" i18n-alt />
    } @else {
      <img alt="Trail" ngSrc="/assets/icons/map-legend-icons/sno/icon-snowtrails-trail-sat.svg" i18n-alt />
    }
    <div>
      <strong i18n>Trail: </strong>
      <span i18n>Publicly maintained trails</span>
    </div>
  </li>
  <li class="trail-type-layer">
    @if (!isShowingSatellite) {
      <img alt="Club Trail" ngSrc="/assets/icons/map-legend-icons/sno/icon-snowtrails-clubtrail.svg" i18n-alt />
    } @else {
      <img alt="Club Trail" ngSrc="/assets/icons/map-legend-icons/sno/icon-snowtrails-clubtrail-sat.svg" i18n-alt />
    }
    <div>
      <strong i18n>Club: </strong>
      <span i18n>Club maintained trails</span>
    </div>
  </li>
  <li class="trail-type-layer">
    @if (!isShowingSatellite) {
      <img
        alt="Unmaintained Trail"
        ngSrc="/assets/icons/map-legend-icons/sno/icon-snowtrails-unmaintained.svg"
        i18n-alt
      />
    } @else {
      <img
        alt="Unmaintained Trail"
        ngSrc="/assets/icons/map-legend-icons/sno/icon-snowtrails-unmaintained-sat.svg"
        i18n-alt
      />
    }
    <div>
      <strong i18n>Unmaintained: </strong>
      <span i18n>Legal riding opportunity, not maintained</span>
    </div>
  </li>
  <li class="trail-type-layer">
    <img alt="Closed Trail" ngSrc="/assets/icons/map-legend-icons/icon-closed-trail.svg" i18n-alt />
    <div>
      <div class="label"><strong i18n>Closed</strong></div>
    </div>
  </li>
</ul>
